/**
 * @name Code.js
 * @author 양진영
 * @since 2025. 02. 26.
 * @description
 * 공통코드 관리
 */
import CodePage from "./code/CodePage";

const Code = () => <CodePage />;

export { Code };
